
import { Fragment, useMemo} from 'react';
import { MahasulListProps } from '../../../../../helpers/models/Models';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/store';
import AppTable from '../../../../../constants/AppTable';
import { mahasulEntryListDateWise } from '../../../../../helpers/submitDataOnServer';
import { useDispatch } from 'react-redux';
import { formatMoney } from '../../../../../helpers/DateFormat';

const EntryListView = () => {
  const { MahasulEntryList } = useSelector((state: RootState) => state.accounts)
  const columns = [
    { header: 'SN', accessor: 'sn', sortable: false },
    { header: 'Member Name', accessor: 'mem_name', sortable: true },
    { header: 'Marga/Tole', accessor: 'marga_tole_name', sortable: false },
    { header: 'Consume Amt', accessor: 'consume_amt', sortable: false },
    { header: 'Consumer unit', accessor: 'consume_unit', sortable: false },
    { header: 'Unit Total', accessor: 'unit_total', sortable: false },
    { header: 'Reader', accessor: 'reader', sortable: false },
    { header: 'Meter Status', accessor: 'meter_status', sortable: false },
  ];
  const modifiedData = useMemo(() => {
    if (!MahasulEntryList) return [];
    return MahasulEntryList.results.map((item: MahasulListProps) => ({
      sn: item.sn,
      mem_name: `${item.member_sn}. ${item.mem_name}`,
      marga_tole_name: item.marga_tole_name,
      member_sn: item.member_sn,
      consume_amt: formatMoney(item.consume_amt||0),
      consume_unit: item.consume_unit,
      unit_total: item.unit_total,
      reader: item.reader_name,
      meter_status: item.meter_status === 1 ? "Meter Bigreko" : item.meter_status === 2 ? 'Pani Khapat nabhayako' : item.meter_status === 3 ? 'Sewa Banda Bhayako' : "-",
    }));
  }, [MahasulEntryList]);
  const dispatch = useDispatch();
  return (
    <Fragment>
      <AppTable
        columns={columns}
        data={modifiedData}
        onNext={async () => {
          if(MahasulEntryList?.next){
          await mahasulEntryListDateWise(dispatch, MahasulEntryList?.next || "");
          }
        }}
        onPrev={async () => {
          if(MahasulEntryList?.previous){
            await mahasulEntryListDateWise(dispatch, MahasulEntryList?.previous || "")
          }
        }}

      />

    </Fragment>
  );
};

export default EntryListView;
